define('UI',[
    'jquery',
    'underscore'
], function ($, _, BtnClassic) {
    /**
     * Detects if element is visible in viewport
     * @returns {boolean}
     */
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
  };

    /**
     * Detects if element is overflowing
     * @returns {boolean}
     */
    $.fn.isOverflowing = function() {
        var e = this[0];
        return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
    };

    /**
     * Returns visible height of an element
     * @returns {number}
     */
    $.fn.visibleHeight = function() {
        var viewportTop = $(window).scrollTop();
        var scrollBottom = viewportTop + $(window).height();
        var elementTop = this.offset().top;
        var elementBottom = elementTop + this.outerHeight();
        var visibleTop = elementTop < viewportTop ? viewportTop : elementTop;
        var visibleBottom = elementBottom > scrollBottom ? scrollBottom : elementBottom;

        return visibleBottom - visibleTop
    };

    /**
     * Returns the number of lines
     * @returns {number}
     */
    $.fn.linesCount = function () {
        return Math.round(this.outerHeight() / parseInt(this.css('line-height').replace('px', '')));
    }

    // alias for template btnClassic
    window.templates.btnClassic = function(text,icon,classes,attributes,tag){
        tag = tag || 'button';
        classes = classes || '';
        attributes = _(attributes).defaults({type:'button'});
        if(tag === 'a') delete attributes.type;
        var openingTag, closingTag = '</'+tag+'>', content = '';
        openingTag = '<'+tag+' class="btn-classic '+classes+'"';
        _(attributes).mapObject(function(val,key){
            openingTag += ' '+key+'="'+val+'"';
        });
        openingTag += '>';

        if(!!icon){
            content += '<i class="icon-'+icon+'"></i>';
        }
        if(text){
            content += '<span class="btn-classic__base">'+text+'</span>';
        }

        return openingTag+content+closingTag;
    }
});
